export const getCargoPlanTableHTML = (rowsCount = 6, colsCount = 3) => {
    const defaultHeaders = ["Holds", "Total MT", "Status"];

    let headersHTML = "";
    for (let c = 0; c < colsCount; c++) {
        const headerText = c < defaultHeaders.length ? defaultHeaders[c] : `Header ${c + 1}`;
        headersHTML += `
            <th align="center" valign="middle" style="background:#ff0000;color:#fff;border:1px solid #000;padding:5px;text-align:center;vertical-align:middle;">
                ${headerText}
            </th>
        `;
    }

    let bodyRowsHTML = "";
    for (let r = 0; r < rowsCount; r++) {
        bodyRowsHTML += `<tr>`;
        for (let c = 0; c < colsCount; c++) {
            bodyRowsHTML += `
                <td align="center" valign="middle" style="background:#ffffff;border:1px solid #000;padding:5px;text-align:center;vertical-align:middle;">
                    &nbsp;
                </td>
            `;
        }
        bodyRowsHTML += `</tr>`;
    }

return `
    <figure  style="margin:20px 0 !important;" class="table">
        <table 
            width="100%" 
            align="center"
            border="1" 
            cellpadding="0" 
            cellspacing="0"
            style="width:100% !important;min-width:100% !important;border-collapse:collapse;border:1px solid #000;mso-table-lspace:0pt;mso-table-rspace:0pt;table-layout:fixed;"
        >
            <thead>
            <tr>
                <th colspan="${colsCount}" align="center" valign="middle" style="background:#001f5b;color:#fff;border:1px solid #000;padding:5px;text-align:center;vertical-align:middle;">
                TENTATIVE CARGO PLAN
                </th>
            </tr>
            <tr>
                ${headersHTML}
            </tr>
            </thead>
            <tbody>
            ${bodyRowsHTML}
            </tbody>
        </table>
    </figure>

    <p><em><strong>MAXIMUM SAILING DRAFT:</strong> 0</em></p>
`;
};